module.exports = __webpack_public_path__ + "static/hero_app-2e8f68c075d70c7710970a0126d7aef9.png";